import './styles.scss'; //build the styles in scss and then compiles to index.css.
import './sticky-anchor-link-area.js';